<template>
  <div class="top-banner">
  <b-carousel
    id="carousel-fade"
    fade
    indicators
    img-width="1024"
    img-height="480"
    :interval="3000"
  >
    <a href="https://okaimono.ohisamak-ehonya.com/" target="_blank">
      <b-carousel-slide img-src="/static/images/top-banner/2021_banner.jpg" alt="" class="img-fluid"></b-carousel-slide>
    </a>
    <router-link to="/campaign.html">
      <b-carousel-slide img-src="/static/images/top-banner/banner_tanetane_2.jpg" alt="" class="img-fluid"></b-carousel-slide>
    </router-link>
    <a href="https://www.youtube.com/watch?v=RS7270_xCg0" target="_blank">
      <b-carousel-slide img-src="/static/images/top-banner/banner_okaimono.jpg" alt="" class="img-fluid"></b-carousel-slide>
    </a>
    <router-link to="/houkoku.html">
      <b-carousel-slide img-src="/static/images/top-banner/banner_applepie.jpg" alt="" class="img-fluid"></b-carousel-slide>
    </router-link>
    <a href="https://www.youtube.com/watch?v=2mk1uhFMkAQ" target="_blank">
      <b-carousel-slide img-src="/static/images/top-banner/banner_presentdoga.jpg" alt="" class="img-fluid"></b-carousel-slide>
    </a>
  </b-carousel>
</div>
</template>

<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TopBanner.vue